import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { IPanelNotification } from '@/store/types/notification';
import axiosInstance from '@/utils/axiosInstance';


export type  PanelNotification = IPanelNotification;

export const getPanelNotifications = createAsyncThunk<
  PanelNotification[],
  void,
  { rejectValue: string }
>('panelNotification/fetchAll', async (_, { rejectWithValue }) => {
  try {
    const response = await axios.get('/panel-notification');
    return response.data;
  } catch (error: any) {
    return rejectWithValue(
      error?.response?.data?.message || 'Failed to fetch notifications',
    );
  }
});


// Mark single notification as read

export const markNotificationAsRead = createAsyncThunk<
  { notificationId: string },
  string,
  { rejectValue: string }
>('panelNotification/markAsRead', async (notificationId, { rejectWithValue }) => {
  try {
  await axiosInstance.patch(
      `/panel-notification/mark/read/${notificationId}`,
    );
    return { notificationId }
  } catch (error: any) {
    return rejectWithValue(
      error?.response?.data?.message || 'Failed to mark notification as read',
    );
  }
});


// Mark all notifications as read

export const markAllNotificationsAsRead = createAsyncThunk<
  void,
  void,
  { rejectValue: string }
>('panelNotification/markAllAsRead', async (_, { rejectWithValue }) => {
  try {
    await axiosInstance.patch('/panel-notification/mark/read/all');
  } catch (error: any) {
    return rejectWithValue(
      error?.response?.data?.message ||
        'Failed to mark all notifications as read',
    );
  }
});
